import { Box, makeStyles, useTheme } from '@material-ui/core'
import React from 'react'
import ButtonWithPermissions, {
  ButtonWithPermissionsProps
} from '../../buttonWithPermissions/buttonWithPermissions'
import { SplitButton, SplitButtonProps } from '../splitButton/splitButton'
import { styles } from './cardActions.styles'

export interface CardActionProps
  extends Omit<
    ButtonWithPermissionsProps,
    'onClick' | 'size' | 'color' | 'variant' | 'hasPermission'
  > {
  label?: string
  hasPermission?: boolean
  handleActionClick?: () => void
  size?: 'small' | 'large'
  color?: 'primary' | 'secondary'
  variant?: 'text' | 'outlined' | 'contained'
  visibleIf?: boolean
  splitButton?: SplitButtonProps
}

export const CardAction: React.FC<CardActionProps> = ({
  label = '',
  hasPermission = true,
  handleActionClick = () => {},
  size = 'small',
  color = 'primary',
  splitButton,
  ...props
}) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  return splitButton?.options && splitButton.options.length > 0 ? (
    <Box className={classes.cardSplitButton}>
      <SplitButton {...splitButton} />
    </Box>
  ) : (
    <ButtonWithPermissions
      size={size}
      color={color}
      hasPermission={hasPermission}
      onClick={handleActionClick}
      {...props}
    >
      {label}
    </ButtonWithPermissions>
  )
}
